module.exports = __webpack_public_path__ + "static/media/nido1.3b6aff35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/nido1.jpg
// module id = 169
// module chunks = 0